import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import Typography from '@mui/material/Typography';

import type { SvgIconTypeMap } from '@mui/material';

interface DeliveryCardsProps {
  Icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  deliveryType: string;
  time: string;
  isActive?: boolean;
  price?: string;
}

const DeliveryCards = ({ Icon, deliveryType, time, isActive, price }: DeliveryCardsProps) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        p: 2,
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'start',
        bgcolor: isActive ? theme.palette.primary.main : theme.palette.primary.lighter,
        gap: '0.5rem',
        borderRadius: '1rem',
      }}
    >
      <Icon sx={{ width: '40px', height: 'auto' }} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
        <Typography
          variant="body1"
          color={isActive ? theme.palette.common.white : theme.palette.secondary.main}
          fontWeight={theme.typography.fontWeightMedium}
        >
          {deliveryType}
        </Typography>
        <Typography
          variant="body2"
          color={isActive ? theme.palette.common.white : theme.palette.primary.main}
        >
          {time}
        </Typography>
        <Typography
          variant="body2"
          color={isActive ? theme.palette.common.white : theme.palette.secondary.main}
        >
          {price}
        </Typography>
      </Box>
    </Card>
  );
};

export default DeliveryCards;
